'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

require('./Field.css');

require('./Field-mobile.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextField = function (_React$Component) {
  _inherits(TextField, _React$Component);

  function TextField(props) {
    _classCallCheck(this, TextField);

    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

    _this.handleFocus = function (e) {
      _this.setState({ hasFocus: e.target === document.activeElement });
    };

    _this.handleChange = function (e, rawValue) {
      _this.setState({ value: rawValue || e.target.value || _this.props.hintText }, function () {
        return _this.props.onChange && _this.props.onChange(_this.state.value);
      });
    };

    _this.componentDidMount = function (e) {
      if (!_this.state.value && !!_this.state.defaultValue) {
        _this.nextTick = setTimeout(function () {
          return _this.handleChange(null, _this.state.defaultValue);
        }, 100);
      }
    };

    _this.inputId = _shortid2.default.generate();
    _this.state = {
      value: _this.props.hintText || '',
      defaultValue: _this.props.defaultValue,
      error: _this.props.error,
      phoneError: _this.props.phoneError,
      emailError: _this.props.emailError,
      hasFocus: false
    };
    return _this;
  }

  _createClass(TextField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.error !== this.props.error) {
        this.setState({ error: nextProps.error });
      }
      if (nextProps.phoneError !== this.props.phoneError) {
        this.setState({ phoneError: nextProps.phoneError });
      }
      if (nextProps.emailError !== this.props.emailError) {
        this.setState({ emailError: nextProps.emailError });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_textfield' + (this.state.value ? ' wsequiz_value' : '') + (this.state.hasFocus ? ' wsequiz_focus' : '') + (this.state.error || this.state.phoneError || this.state.emailError ? ' wsequiz_error' : '') },
        _react2.default.createElement(
          'label',
          { htmlFor: this.inputId },
          this.props.text,
          ' ',
          _react2.default.createElement(
            'span',
            null,
            this.props.subtext
          ),
          this.state.error ? '*' : '',
          this.state.phoneError || this.state.emailError ? '**' : ''
        ),
        _react2.default.createElement('input', { id: this.inputId,
          type: this.props.selected === 'number' ? 'number' : 'text',
          value: this.state.value,
          onFocus: this.handleFocus,
          onBlur: this.handleFocus,
          onChange: this.handleChange }),
        _react2.default.createElement('hr', { 'aria-hidden': true }),
        _react2.default.createElement('hr', { 'aria-hidden': true })
      );
    }
  }]);

  return TextField;
}(_react2.default.Component);

exports.default = TextField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/blocks/TextField.js
// module id = 819
// module chunks = 0